/**
 * created by li si yi
 * 敏感词等弹窗
 */
import React, {Component} from 'react';
import {Empty, Modal, message, Pagination} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import BaseComponent from "../../../base/BaseComponent";
import BaseTable from "../../components/baseTable/BaseTable";
import moment from "moment";

const type = [
    {
        name: '敏感词',
        type: 'SENSITIVE',
        title1: '错误词',
        title2: '建议替换词',
    },
    {
        name: '隐私信息',
        type: 'PRIVACY_INFORMATION',
        title1: '隐私信息',
        title2: '',
    },
    {
        name: '敏感人物',
        type: 'PERSON_SENSITIVE',
        title1: '敏感人物',
        title2: '人物职位',
    },
    {
        name: '非法链接',
        type: 'ILLEGALITY_LINK',
        title1: '非法链接',
        title2: '检测方式',
    },
    {
        name: '疑似外链',
        type: 'OUTSIDE_CHAIN',
        title1: '疑似外链',
        title2: '',
    },
];
export default class SensitivityModal extends BaseComponent {
    static defaultProps = {
        imgAll: [],
        onOk: () => {
        }
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            contentVisible: false,//显示
            params: {
                start: 1,
                size: 10,
            },
            deptName: '',
            mediaName: '',
            storyName:'',
            startTime:'',
            endTime:'',
            dataSource: [],
            currentClick: {},
            count: 10,
        };
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div>
                {/*弹窗*/}
                {this.renderModal()}
            </div>
        )
    }

    //列表数据
    renderModal() {
        const {contentVisible, dataSource, currentClick, count} = this.state;
        let columns = [];
        dataSource && dataSource.length && dataSource.map((item, index) => {
            columns = [
                {
                    title: '序号',
                    dataIndex: 'serialNumber',
                    key: 'serialNumber',
                    width: 70,
                    ellipsis: true,
                    render: (text, record, index) => (this.state.params.start - 1) * this.state.params.size + (index + 1)
                },
                {
                    title: this.state.currentClick.title1,
                    dataIndex: 'word',
                    key: 'word',
                    width: this.state.currentClick.title1 && item.category !== 'SENSITIVE' ? 150 : item.category === 'SENSITIVE' ? 100 : 0,
                    // ellipsis: true,
                    render: (text) => {
                        return (
                            <div title={text ? text : ''} style={{
                                width: this.state.currentClick.title1 && item.category !== 'SENSITIVE' ? 150 : item.category === 'SENSITIVE' ? 100 : 0,
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis'
                            }}>{text ? text : ''}</div>
                        )
                    }
                },
                {
                    title: this.state.currentClick.title2,
                    dataIndex: 'correct',
                    key: 'correct',
                    width: this.state.currentClick.title2 ? 120 : 0,
                    // ellipsis: true,
                    render: (text) => {
                        return (
                            <div title={text ? text : ''} style={{
                                width: this.state.currentClick.title2 ? 120 : 0, overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis'
                            }}>{text ? text : ''}</div>
                        )
                    }
                },
                // {
                //     title: '检测方式',
                //     dataIndex: 'wrongSource',
                //     key: 'wrongSource',
                //     width: 80,
                //     ellipsis: true,
                //     render: (text) => {
                //         let check;
                //         switch (text) {
                //             case 'CLOUD_CHECK':
                //                 check = '云端检测';
                //                 break;
                //             case 'LOCAL_CHECK':
                //                 check = '本地检测';
                //                 break;
                //             default:
                //                 check = '';
                //                 break;
                //         }
                //         return (
                //             <span>{check ? check : ""}</span>
                //         )
                //     }
                // },
                {
                    title: '所在稿件',
                    dataIndex: 'storyName',
                    key: 'storyName',
                    width: 130,
                    ellipsis: true,
                    render: (text, record) => {
                        return (
                            <span>{record.data && record.data.storyName ? record.data.storyName : ""}</span>
                        )
                    }
                },
                {
                    title: '稿件作者',
                    dataIndex: 'createStoryUserName',
                    key: 'createStoryUserName',
                    width: 110,
                    ellipsis: true,
                    render: (text, record) => {
                        return (
                            <div>
                                {record.data && record.data.createStoryUserName ? record.data.createStoryUserName : record.data && record.data.createUserName ? record.data.createUserName : ""}
                            </div>
                        )
                    }
                },
                {
                    title: '单位',
                    dataIndex: 'createStorydeptName',
                    key: 'createStorydeptName',
                    width: 110,
                    ellipsis: true,
                    render: (text, record) => {
                        return (
                            <div>
                                {record.data && record.data.createStorydeptName ? record.data.createStorydeptName : record.data && record.data.deptName?record.data.deptName:""}
                            </div>
                        )
                    }
                },
                {
                    title: '创建时间',
                    dataIndex: 'createTime',
                    key: 'createTime',
                    width: 150,
                    ellipsis: true,
                    render: (text) => {
                        return (
                            <span>{text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : ''}</span>
                        )
                    }
                },
                {
                    title: '操作',
                    width: 80,
                    ellipsis: true,
                    render: (text, record) => {
                        return (
                            <span style={{color: '#0050B3', cursor: 'pointer'}} onClick={() => {
                                if(!record.data){
                                    message.destroy();
                                    message.error('这篇稿件异常！');
                                    return
                                }
                                if(!record.data.check_info_url){
                                    message.destroy();
                                    message.error('这篇稿件已被删除！');
                                    return
                                }
                                this.getContent(record.data.check_info_url, (res) => {
                                    if (!res) {
                                        message.destroy();
                                        message.error('这篇稿件已被删除！');
                                        return
                                    } else {
                                        window.openPage({
                                            url: "/cm-sites/pms/framereact/index.html#/view/contentSecurityCenter/details",
                                            params: {
                                                checkUrl: record.data,
                                                checkAll: record,
                                            },
                                        })
                                    }
                                });
                            }}>查看详情</span>
                        )
                    }
                },
            ];
        });
        return (
            <>
                <Modal title={
                    <div>
                        <span>{currentClick.title}（{currentClick.thisCount ? currentClick.thisCount : 0}个）</span>
                        {/*<span>（云端检测：{currentClick.thisCloud ? currentClick.thisCloud : 0} 条、本地检测：{currentClick.thisLocal ? currentClick.thisLocal : 0} 条）</span>*/}
                    </div>
                } width={1200} footer={this.state.dataSource.length ? this.renderFooter() : null}
                       className={'modalStyle'}
                       visible={contentVisible}
                       onCancel={this.handleCancelContent}
                       bodyStyle={{height: 370}}>
                    <Scrollbars style={{paddingLeft: 5, width: '100%', height: 610}} autoHide>
                        <BaseTable dataSource={dataSource}
                                   columns={columns}
                                   pagination={false} rowKey="id"/>
                    </Scrollbars>
                </Modal>
                <style>
                    {`
                        .modalStyle .ant-modal-content{
                            height:770px;
                        }
                        .modalStyle .pagination{
                            border:none;
                        }
                        .modalStyle .ant-modal-footer{
                            padding: 0px 16px;
                            margin-top: 263px;
                        }
                        .modalStyle .ant-table-placeholder{
                           height:600px;
                           display: flex;
                           justify-content: center;
                           align-items: center;
                           border-bottom:none;
                        }
                    `}
                </style>
            </>
        )
    }

    // 分页
    renderFooter = () => {
        let {params, count} = this.state;
        let {start, size} = params;
        return (
            <div className={'pagination'} style={{marginTop: '0px',}}>
                <div style={{padding: "0 10px 0"}}>共{count}条数据</div>
                <Pagination
                    showSizeChanger
                    current={start}
                    pageSize={size}
                    total={count}
                    showQuickJumper={true}
                    onChange={this.pageChange}
                    onShowSizeChange={this.pageChange}
                />
            </div>
        )
    };
    //不返回内容则稿件被删除
    getContent = (url, callback) => {
        this.request({
            url: url,
            callBack: (res) => {
                let status = false;
                if (!res) {
                    if (callback) {
                        callback(status)
                    }
                }else {
                    if (callback) {
                        callback(!status)
                    }
                }
            }
        })
    };
    // 获取数据
    getItemDataSource = (type) => {
        let {deptName, mediaName} = this.state;
        this.setState({type});
        let params = {
            ...this.state.params,
            "queryStr": {
                "queryRelationTypeEnum": "AND",
                "queryList": []
            },
            "ifNeedWordsDate": false,
            type: type,
        };
        if (this.state.deptName) {
            params.queryStr.queryList.push({
                "queryTypeEnum": "IS",
                "fieldName": "data.createStorydeptName",
                "queryRelationTypeEnum": "AND",
                "value": deptName,
                "valueTypeEnum": "STRING",
                "queryList": null
            })
        }
        if (this.state.mediaName) {
            params.queryStr.queryList.push({
                "queryTypeEnum": "IS",
                "fieldName": "data.createStoryMediaName",
                "queryRelationTypeEnum": "AND",
                "value": mediaName,
                "valueTypeEnum": "STRING",
                "queryList": null
            })
        }
        if (this.state.startTime && this.state.endTime) {
            params.queryStr.queryList.push(
                {
                    "queryTypeEnum": "GTE",
                    "fieldName": "createTime",
                    "queryRelationTypeEnum": "AND",
                    "value": this.state.startTime,
                    "valueTypeEnum": "LONG",
                    "queryList": null
                },
                {
                    "queryTypeEnum": "LTE",
                    "fieldName": "createTime",
                    "queryRelationTypeEnum": "AND",
                    "value": this.state.endTime,
                    "valueTypeEnum": "LONG",
                    "queryList": null
                }
            )
        }
        if (this.state.storyName) {
            params.queryStr.queryList.push(
                {
                    "queryTypeEnum": "LIKE",
                    "fieldName": "data.storyName",
                    "queryRelationTypeEnum": "AND",
                    "value": this.state.storyName,
                    "valueTypeEnum": "BOOLEAN",
                    "queryList": null
                }
            )
        }
        this.request({
            url: "/cm-sites-sys/contentCheck/getCheckResultObjectByTypt",
            body: params,
            method: 'post',
            contentType: 'json',
            callBack: (res) => {
                let dataSource = [];
                let count = 10;
                if (res) {
                    dataSource = res.data;
                    count = res.count;
                } else {
                    message.error("数据获取失败！");
                }
                this.setState({dataSource, count});
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };
    // 显示
    showModal = (thisData, item, params) => {
        let thisTable = type.find(Item => Item.type === thisData.thisType);
        this.setState({
            contentVisible: true,
            deptName: params.deptName,
            mediaName: params.mediaName,
            storyName: params.storyName,
            startTime: params.startTime,
            endTime: params.endTime,
            params: {
                start: 1,
                size: 10
            },
            currentClick: {
                ...item,
                ...thisData,
                title1: thisTable.title1,//列表第二第三列表头
                title2: thisTable.title2,
            }
        }, () => {
            this.getItemDataSource(thisData.thisType);
        });
    };
    // 取消
    handleCancelContent = () => {
        this.setState({contentVisible: false});
    };

    // 分页改变
    pageChange = (start, size) => {
        let {params} = this.state;
        // console.log(start, size);
        let {type} = this.state;
        params.start = start;
        params.size = size;
        this.getItemDataSource(type);//分页切换
    };
}